import { useCallback, useState } from 'react';
import { FaUserPlus } from "react-icons/fa";
import { LuMaximize, LuMinimize } from "react-icons/lu";
import { MdCallEnd } from "react-icons/md";
import { useVideoCall } from '../../../contexts/videoCall';
import { InvitationCall } from '../../InvitationCall';
import { Container, Content, DefaultButton, LoadingSpinner, Off, TooltipWrapper } from './styled';


const WINDOW_MODE = {
  DEFAULT: 'DEFAULT',
  COLLAPSED: 'COLLAPSED'
}

const CALL_OPTIONS = {
  MI4U: 'VIDEOCHAMADA_MI4U',
  MEET: 'VIDEOCHAMADA_MEET'
};

export function Controls({ onToggleWindowMode, windowMode, isNeuronMeet, accessLevel }) {

  const [isClosing, setIsClosing] = useState(false);
  const [showInvitation, setShowInvitation] = useState(false);

  const { dataCall, closeVideoCall } = useVideoCall();

  const handleCloseVideoCall = useCallback(async () => {
    if (isClosing) return
    setIsClosing(true);
    try {
      await closeVideoCall(isNeuronMeet ? CALL_OPTIONS.MEET : CALL_OPTIONS.MI4U);
    } catch (error) {
      console.error('Erro ao encerrar videochamada:', error);
    } finally {
      setIsClosing(false);
    }
  }, [closeVideoCall, isClosing, isNeuronMeet]);

  return (
    <Container onMouseDown={(e) => e.stopPropagation()} accessLevel={accessLevel}>
      <Content accessLevel={accessLevel}>
        <DefaultButton
          onClick={() => onToggleWindowMode()}
          disabled={isClosing}
          $isClosing={isClosing}
          accessLevel={accessLevel}
        >
          {windowMode === WINDOW_MODE.DEFAULT
            ? <LuMinimize size={23} />
            : <LuMaximize size={23} />
          }
        </DefaultButton>
        {!isNeuronMeet && (
          <TooltipWrapper accessLevel={accessLevel}>
            <DefaultButton
              onClick={() => setShowInvitation(!showInvitation)}
              disabled={isClosing}
              $isClosing={isClosing}
              accessLevel={accessLevel}
            >
              <FaUserPlus size={23} />
            </DefaultButton>
            {showInvitation && !isClosing && (
              <InvitationCall
                customer={dataCall?.customer}
                onClose={() => setShowInvitation(false)}
                accessLevel={accessLevel}
              />
            )}
          </TooltipWrapper>
        )}
        <Off
          onClick={handleCloseVideoCall}
          disabled={isClosing}
          $isClosing={isClosing}
          accessLevel={accessLevel}
        >
          {isClosing ? (
            <LoadingSpinner className="loader-red" accessLevel={accessLevel}>
              <div />
            </LoadingSpinner>
          ) : (
            <MdCallEnd size={23} />
          )}
        </Off>
      </Content>
    </Container>
  )
}